import {doGet, doPost} from './Base';


const getDomains = async () => {
    return await doGet('/linkoln_domains');
};


const reserveDomain = async (domain, subdomain) => {
    return await doPost('/reserve_subdomain', {
        "domain": domain,
        "subdomain": subdomain
    });
};


const releaseDomain = async (domain, subdomain) => {
    return await doPost('/release_subdomain', {
        "domain": domain,
        "subdomain": subdomain
    });
};


export {getDomains, reserveDomain, releaseDomain};
export default getDomains;
